<template>
    <div class="my_info">
        <el-form label-width="100px">
            <el-form-item label="账号" :model="infoForm" >
                <el-input disabled v-model="infoForm.account"></el-input>
            </el-form-item>
            <el-form-item label="名称">
                <el-input v-model="infoForm.name"></el-input>
            </el-form-item>
            <el-form-item label="手机号">
                <el-input v-model="infoForm.phone"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary"  @click="updateData">更新设置</el-button>
                <el-button size="small" type="info" plain @click="toLogin">修改密码</el-button>
            </el-form-item>
        </el-form>

    </div>
</template>
<script>
import { updateCenter,getCenterInfo } from '@/api/api'
export default {
  data () {
    return {
      infoForm: {
        account: '',
        name: '',
        phone: ''
      },
      staffAccountId:''
    }
  },
  mounted(){
    this.getInfo()
  },
  methods: {
    async getInfo(){
      const res = await getCenterInfo()
      if(res.status==0){
        let obj = res.data
        
        this.infoForm.account = obj.staffAccountNum
        this.infoForm.name = obj.staffName
        this.infoForm.phone = obj.staffPhone
        this.staffAccountId = obj.staffAccountId
      }
      
    },
    async updateData(){
      let query = {
        data:{
          staffName:this.infoForm.name,
          staffPhone:this.infoForm.phone,
          staffAccountId:this.staffAccountId
        }
       
      }
      const res = await updateCenter(query)
      if(res.status=='A0001'){
        this.$DonMessage.error('更新失败~请稍后再试')
      }
      if(res.status==0){
        this.$DonMessage.success('更新成功')
        this.getInfo()
      }
    },
    toLogin () {
      this.$router.push({name:'/login',params:{showModify:true,from:'/center'}})
    }
  }
}
</script>
<style lang="scss" scoped>
.my_info{
    width: 300px;
}
</style>
